/* Poolfritz – Modellbereich: Vergleichsauswahl (bis 4 Modelle, im Browser gemerkt) */
(function () {
  var KEY = window.PFM_KEY || 'pfm_vergleich', MAX = 4;
  function lesen() {
    try { var a = JSON.parse(window.localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function schreiben(a) { try { window.localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  function aktualisieren() {
    var liste = lesen();
    document.querySelectorAll('[data-pfm-vergleich]').forEach(function (b) {
      var drin = liste.some(function (x) { return x.h === b.getAttribute('data-pfm-vergleich'); });
      b.setAttribute('aria-pressed', drin ? 'true' : 'false');
      var l = b.querySelector('[data-pfm-label]');
      if (l) l.textContent = drin ? 'Im Vergleich' : 'Vergleichen';
    });
    var leiste = document.querySelector('[data-pfm-leiste]');
    if (!leiste) return;
    leiste.hidden = liste.length === 0 || document.body.hasAttribute('data-pfm-vergleichsseite');
    var n = leiste.querySelector('[data-pfm-anzahl]'); if (n) n.textContent = liste.length;
    var namen = leiste.querySelector('[data-pfm-namen]');
    if (namen) namen.textContent = liste.map(function (x) { return x.t; }).join(' · ');
    var link = leiste.querySelector('[data-pfm-leiste-link]');
    if (link) link.href = (leiste.getAttribute('data-ziel') || '/pages/ueberdachungen-vergleichen') +
      '?modelle=' + encodeURIComponent(liste.map(function (x) { return x.h; }).join(','));
  }

  function umschalten(h, t) {
    var liste = lesen();
    var i = liste.findIndex(function (x) { return x.h === h; });
    if (i > -1) { liste.splice(i, 1); }
    else {
      if (liste.length >= MAX) { liste.shift(); }
      liste.push({ h: h, t: t || h });
    }
    schreiben(liste); aktualisieren();
    document.dispatchEvent(new CustomEvent('pfm:vergleich', { detail: liste }));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pfm-vergleich]');
    if (b) { e.preventDefault(); umschalten(b.getAttribute('data-pfm-vergleich'), b.getAttribute('data-titel')); return; }
    if (e.target.closest('[data-pfm-leeren]')) { schreiben([]); aktualisieren(); document.dispatchEvent(new CustomEvent('pfm:vergleich', { detail: [] })); }
  });

  window.PFM = { lesen: lesen, schreiben: schreiben, aktualisieren: aktualisieren, umschalten: umschalten, MAX: MAX };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aktualisieren); else aktualisieren();
})();
